import { createStyles, makeStyles, Paper, Popper } from "@material-ui/core";

export const paperStyle = makeStyles((theme) =>
	createStyles({
		paper: {
			boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
			borderRadius: "4px",
			backgroundColor: theme.palette.background.paper,
		},
	})
);

export const OutlinedPopper = (props: any) => {
	return (
		<Popper
			{...props}
			popperOptions={{
				modifiers: {
					offset: {
						offset: "0,-10",
					},
					preventOverflow: {
						enabled: false,
					},
					hide: {
						enabled: false,
					},
				},
			}}
			placement="top-start"
		/>
	);
};

export const PaperComponent1 = (props: any) => {
	return <Paper elevation={0} style={{ borderRadius: "4px", marginRight: "-1px", marginLeft: ".5px" }} {...props} />;
};

export const PaperComponent2 = (props: any) => {
	return <Paper elevation={0} style={{ borderRadius: "4px", marginLeft: "1px" }} {...props} />;
};

export const PaperComponent = (props: any) => {
	return <Paper elevation={0} style={{ borderRadius: "4px" }} {...props} />;
};
